<template>
  <div class="content">
    <div class="reset-wrapper">
      <div class="reset">
        <h3>Request password reset</h3>
        <div class="b-form-group form-group" role="group">
          Please enter the email address associated with the account. You may need to check your junk/spam folder.
        </div>
        <form @submit.prevent="handleForgotPassword" class="form" ref="formContainer">
         
          <div class="b-form-group form-group" role="group">
            <!-- <label class="col-form-label pt-0">Email: </label> -->
            <input id="email"
                   v-model="form.email"
                   class="form-control form__input"
                   required
                   type="email">
          </div>

          <div class="button-group">
            <button type="submit" class="col-md-12 col-12 btn btn--reset">Submit</button>
            <router-link to="/login" class="form__link">Back to login</router-link>
          </div>
        </form>
      </div>

    </div>
  </div>

</template>

<script>
import {
  forgotPassword
} from '@/api/userApi';
import {
  FORGOT_PASSWORD_SUCCESS_MESSAGE,
  NO_SUCH_USER_MESSAGE
} from '@/api/ajaxActionResponse';
export default {
  name: 'forgot-password-page',
  data() {
    return {
      form: {
        username: null,
        email: null
      },
    }
  },
  methods: {
    handleForgotPassword() {
      forgotPassword(this.form.email)
      .then(() => {
        alert('Success. Please check your email for instruction to reset password.');
      })
      .catch((err) => {
        alert(JSON.stringify(err));
      });
    }
  }
}
</script>

<style scoped lang="scss">
  @import "../../stylesheets/mixins/alignment";
  $color-base: #0060ff;
  .content {
    width: 100%;
    height: auto;
    background: url("../../assets/images/bg.jpg") no-repeat center fixed;     // TODO image subject to copyright
    background-size: cover;
    position: relative;
  }
  .reset-wrapper {
    height: 100vh;
    width: 100%;
    position: relative;
  }

  .reset {
    background-color: #fff;
    padding: 2.0rem;
    -moz-box-shadow: 0 2px 2px 0 rgba(0,0,0,0.14),0 3px 1px -2px rgba(0,0,0,0.12),0 1px 5px 0 rgba(0,0,0,0.2);
    box-shadow: 0 2px 2px 0 rgba(0,0,0,0.14),0 3px 1px -2px rgba(0,0,0,0.12),0 1px 5px 0 rgba(0,0,0,0.2);

    @include absoluteCenter(380px);
  }
  .reset__introduction {
    color: darken(gray, 10%);
    font-size: 14px;
    text-align: center;
  }
  .btn--reset {
    color: #fff;
    background-color: $color-base;
    &:hover {
      background-color: lighten($color-base, 5%);
    }
  }

  .button-group {
    margin-top: 1.5rem;

    .form__link {
      color: $color-base;
      font-size: 0.85rem;
      margin-top: 0.5rem;
      display: block;

      &:hover {
        text-decoration: underline;
      }
    }
  }

  .form__input {
    font-size: 0.85rem;
  }
  .col-form-label {
    font-size: 14px;
  }

  @media only screen and (max-width: 468px) {
    .reset {
      width: 100%;
    }
  }
</style>
